import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, pass);

      if (email !== "shanna.admin@gmail.com") {
        setLoading(false);
        setError("No tienes permiso para acceder.");
        return;
      }

      setTimeout(() => {
        navigate("/admin/dashboard");
      }, 1200);
    } catch (err) {
      setLoading(false);
      setError("Credenciales incorrectas.");
    }
  };

  return (
    <div className="admin-login-container">
      <form onSubmit={handleLogin} className="admin-login-box">
        
       
        <h3 className="admin-subtitle">Panel Administrativo</h3>

        <div className="input-group">
          <span className="icon">📧</span>
          <input
            type="email"
            placeholder="Correo administrativo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <span className="icon">🔒</span>
          <input
            type="password"
            placeholder="Contraseña"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            required
          />
        </div>

        <button className="admin-btn" type="submit" disabled={loading}>
          {loading ? "Cargando..." : "Entrar"}
        </button>

        {loading && <div className="loader"></div>}
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
};

export default AdminLogin;
